import { serializeCatalogEditor, validateCatalogEditor } from './catalogEditorModel';

export const validateSecurityEditor = (values) => validateCatalogEditor('security', values);
export const serializeSecurityEditor = (sourceConfig, editor, archivedAt) => (
    serializeCatalogEditor(sourceConfig, { ...editor, scope: 'security' }, archivedAt)
);
